// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const ProductSuggestion = ({ data, handleProductSuggestedClick, onAddNewClick, showAddNew }) => {
//   const [hoveredSuggestion, setHoveredSuggestion] = useState(null);

//   const ulStyle = {
//     listStyle: "none",
//     padding: 0,
//     margin: 0,
//     position: "absolute",
//     backgroundColor: "#fff",
//     border: "1px solid #ccc",
//     zIndex: 1000,
//     maxHeight: "300px",
//     overflowY: "auto",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     width: "250px",
//   };

//   const liStyle = {
//     padding: "8px",
//     cursor: "pointer",
//     display: "flex",
//     justifyContent: "space-between",
//   };

//   return (
//     <ul style={ulStyle}>
//       {data.map((product, index) => (
//         <li
//           key={index}
//           onClick={() => handleProductSuggestedClick(product)}
//           style={{
//             ...liStyle,
//             ...(hoveredSuggestion === index ? { backgroundColor: '#6174DD', color: 'white' } : {})
//           }}
//           onMouseEnter={() => setHoveredSuggestion(index)}
//           onMouseLeave={() => setHoveredSuggestion(null)}
//         >
//           <span>{product?.productName} - ₹{product?.sellPrice}</span>
//           <span>(Count: {product.productCount})</span>
//         </li>
//       ))}
//       {showAddNew && (
//         <div
//           onClick={onAddNewClick}
//           style={{
//             ...liStyle,
//             color: "#007bff",
//             fontWeight: "bold",
//             justifyContent: "center",
//             cursor: "pointer",
//           }}
//         >
//           ➕ Add New Product
//         </div>
//       )}
//     </ul>
//   );
// }

// export default ProductSuggestion;
// import React, { useState, useEffect, useRef } from 'react';

// const ProductSuggestion = ({ 
//   data, 
//   handleProductSuggestedClick, 
//   onAddNewClick, 
//   showAddNew,
//   inputRef,
//   setProductSuggested,
//   focusedProductIndex
// }) => {
//   const [selectedIndex, setSelectedIndex] = useState(-1);
//   const suggestionsRef = useRef(null);
//   const itemRefs = useRef([]);

//   const ulStyle = {
//     listStyle: "none",
//     padding: 0,
//     margin: 0,
//     position: "absolute",
//     backgroundColor: "#fff",
//     border: "1px solid #ccc",
//     zIndex: 1000,
//     maxHeight: "300px",
//     overflowY: "auto",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     width: "250px",
//   };

//   const liStyle = {
//     padding: "8px",
//     cursor: "pointer",
//     display: "flex",
//     justifyContent: "space-between",
//   };

//   // Scroll to keep the selected item in view
//   useEffect(() => {
//     if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
//       itemRefs.current[selectedIndex].scrollIntoView({
//         behavior: 'smooth',
//         block: 'nearest'
//       });
//     }
//   }, [selectedIndex]);

//   // Handle keyboard navigation
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (!inputRef.current) return;

//       if (e.key === 'ArrowDown') {
//         e.preventDefault();
//         const maxIndex = data.length - 1 + (showAddNew ? 1 : 0);
//         const nextIndex = selectedIndex >= maxIndex ? 0 : selectedIndex + 1;
//         setSelectedIndex(nextIndex);
//       } else if (e.key === 'ArrowUp') {
//         e.preventDefault();
//         const maxIndex = data.length - 1 + (showAddNew ? 1 : 0);
//         const prevIndex = selectedIndex <= 0 ? maxIndex : selectedIndex - 1;
//         setSelectedIndex(prevIndex);
//       } else if (e.key === 'Enter' && selectedIndex >= 0) {
//         e.preventDefault();
//         if (selectedIndex < data.length) {
//           handleProductSuggestedClick(data[selectedIndex]);
//         } else if (showAddNew) {
//           onAddNewClick();
//         }
//       } else if (e.key === 'Escape') {
//         setProductSuggested([]);
//         setSelectedIndex(-1);
//         if (inputRef.current) {
//           inputRef.current.blur();
//         }
//       }
//     };

//     if (inputRef.current) {
//       inputRef.current.addEventListener('keydown', handleKeyDown);
//     }

//     return () => {
//       if (inputRef.current) {
//         inputRef.current.removeEventListener('keydown', handleKeyDown);
//       }
//     };
//   }, [data, selectedIndex, showAddNew, inputRef, handleProductSuggestedClick, onAddNewClick, setProductSuggested]);

//   // Reset selected index when suggestions change
//   useEffect(() => {
//     setSelectedIndex(-1);
//     itemRefs.current = itemRefs.current.slice(0, data.length + (showAddNew ? 1 : 0));
//   }, [data, showAddNew]);

//   return (
//     <ul style={ulStyle} ref={suggestionsRef}>
//       {data.map((product, index) => (
//         <li
//           key={index}
//           ref={el => itemRefs.current[index] = el}
//           onClick={() => handleProductSuggestedClick(product)}
//           style={{
//             ...liStyle,
//             backgroundColor: selectedIndex === index ? '#6174DD' : 'transparent',
//             color: selectedIndex === index ? 'white' : 'inherit'
//           }}
//           onMouseEnter={() => setSelectedIndex(index)}
//         >
//           <span>{product?.productName} - ₹{product?.sellPrice}</span>
//           <span>(Count: {product.productCount})</span>
//         </li>
//       ))}
//       {showAddNew && (
//         <div
//           ref={el => itemRefs.current[data.length] = el}
//           onClick={onAddNewClick}
//           style={{
//             ...liStyle,
//             color: selectedIndex === data.length ? 'white' : "#007bff",
//             fontWeight: "bold",
//             justifyContent: "center",
//             cursor: "pointer",
//             backgroundColor: selectedIndex === data.length ? '#6174DD' : 'transparent',
//           }}
//           onMouseEnter={() => setSelectedIndex(data.length)}
//         >
//           ➕ Add New Product
//         </div>
//       )}
//     </ul>
//   );
// }

// export default ProductSuggestion;

// import React, { useState, useEffect, useRef } from 'react';

// const ProductSuggestion = ({ 
//   data, 
//   handleProductSuggestedClick, 
//   onAddNewClick, 
//   showAddNew,
//   inputRef,
//   setProductSuggested,
//   focusedProductIndex
// }) => {
//   const [selectedIndex, setSelectedIndex] = useState(-1);
//   const suggestionsRef = useRef(null);
//   const itemRefs = useRef([]);

//   const ulStyle = {
//     listStyle: "none",
//     padding: 0,
//     margin: 0,
//     position: "absolute",
//     backgroundColor: "#fff",
//     border: "1px solid #ccc",
//     zIndex: 1000,
//     maxHeight: "300px",
//     overflowY: "auto",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     width: "250px",
//   };

//   const liStyle = {
//     padding: "8px",
//     cursor: "pointer",
//     display: "flex",
//     justifyContent: "space-between",
//   };

//   // Scroll to keep the selected item in view
//   useEffect(() => {
//     if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
//       itemRefs.current[selectedIndex].scrollIntoView({
//         behavior: 'smooth',
//         block: 'nearest'
//       });
//     }
//   }, [selectedIndex]);

//   // Handle keyboard navigation
// useEffect(() => {
//   const target = inputRef; // direct DOM element
//   if (!target) return;

//   const handleKeyDown = (e) => {
//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       const maxIndex = data.length - 1 + (showAddNew ? 1 : 0);
//       const nextIndex = selectedIndex >= maxIndex ? 0 : selectedIndex + 1;
//       setSelectedIndex(nextIndex);
//     } else if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       const maxIndex = data.length - 1 + (showAddNew ? 1 : 0);
//       const prevIndex = selectedIndex <= 0 ? maxIndex : selectedIndex - 1;
//       setSelectedIndex(prevIndex);
//     } else if (e.key === 'Enter' && selectedIndex >= 0) {
//       e.preventDefault();
//       if (selectedIndex < data.length) {
//         handleProductSuggestedClick(data[selectedIndex]);
//       } else if (showAddNew) {
//         onAddNewClick();
//       }
//     } else if (e.key === 'Escape') {
//       setProductSuggested([]);
//       setSelectedIndex(-1);
//       target.blur();
//     }
//   };

//   target.addEventListener('keydown', handleKeyDown);
//   return () => target.removeEventListener('keydown', handleKeyDown);
// }, [data, selectedIndex, showAddNew, inputRef, handleProductSuggestedClick, onAddNewClick, setProductSuggested]);


//   // Reset selected index when suggestions change
//   useEffect(() => {
//     setSelectedIndex(-1);
//     itemRefs.current = itemRefs.current.slice(0, data.length + (showAddNew ? 1 : 0));
//   }, [data, showAddNew]);

//   return (
//     <ul style={ulStyle} ref={suggestionsRef}>
//       {data.map((product, index) => (
//         <li
//           key={index}
//           ref={el => itemRefs.current[index] = el}
//           onClick={() => handleProductSuggestedClick(product)}
//           style={{
//             ...liStyle,
//             backgroundColor: selectedIndex === index ? '#6174DD' : 'transparent',
//             color: selectedIndex === index ? 'white' : 'inherit'
//           }}
//           onMouseEnter={() => setSelectedIndex(index)}
//         >
//           <span>{product?.productName} - ₹{product?.sellPrice}</span>
//           <span>(Count: {product.productCount})</span>
//         </li>
//       ))}
//       {showAddNew && (
//         <div
//           ref={el => itemRefs.current[data.length] = el}
//           onClick={onAddNewClick}
//           style={{
//             ...liStyle,
//             color: selectedIndex === data.length ? 'white' : "#007bff",
//             fontWeight: "bold",
//             justifyContent: "center",
//             cursor: "pointer",
//             backgroundColor: selectedIndex === data.length ? '#6174DD' : 'transparent',
//           }}
//           onMouseEnter={() => setSelectedIndex(data.length)}
//         >
//           ➕ Add New Product
//         </div>
//       )}
//     </ul>
//   );
// }

// export default ProductSuggestion;
import React, { useState, useEffect, useRef } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';

const ProductSuggestion = ({
  data,
  handleProductSuggestedClick,
  onAddNewClick,
  showAddNew,
  inputRef,
  setProductSuggested,
  onEditCountClick, // NEW: opens the Update Product Count popup
}) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const suggestionsRef = useRef(null);
  const itemRefs = useRef([]);

  const ulStyle = {
    listStyle: "none",
    padding: 0,
    margin: 0,
    position: "absolute",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    zIndex: 1000,
    maxHeight: "300px",
    overflowY: "auto",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "290px", // slightly wider to fit the edit icon
  };

  const liStyle = {
    padding: "8px 10px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  };

  const productNameStyle = {
    flex: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const countBadgeStyle = (isSelected) => ({
    minWidth: "50px",
    textAlign: "center",
    padding: "2px 6px",
    borderRadius: "12px",
    backgroundColor: isSelected ? "rgba(255,255,255,0.3)" : "#f0f0f0",
    color: isSelected ? "white" : "#333",
    fontSize: "12px",
  });

  // Scroll selected item into view
  useEffect(() => {
    if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedIndex]);

  // Handle keyboard navigation
  useEffect(() => {
    const target = inputRef;
    if (!target) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const maxIndex = data.length - 1 + (showAddNew ? 1 : 0);
        setSelectedIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const maxIndex = data.length - 1 + (showAddNew ? 1 : 0);
        setSelectedIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        e.preventDefault();
        if (selectedIndex < data.length) {
          const item = data[selectedIndex];
          if (item.type === "category") return;
          handleProductSuggestedClick(item);
        } else if (showAddNew) {
          onAddNewClick();
        }
      } else if (e.key === 'Escape') {
        setProductSuggested([]);
        setSelectedIndex(-1);
        target.blur();
      }
    };

    target.addEventListener('keydown', handleKeyDown);
    return () => target.removeEventListener('keydown', handleKeyDown);
  }, [data, selectedIndex, showAddNew, inputRef, handleProductSuggestedClick, onAddNewClick, setProductSuggested]);

  // Reset index
  useEffect(() => {
    setSelectedIndex(-1);
    itemRefs.current = itemRefs.current.slice(0, data.length + (showAddNew ? 1 : 0));
  }, [data, showAddNew]);

  return (
    <ul style={ulStyle} ref={suggestionsRef}>
      {data.map((product, index) => {
        if (product.type === "category") {
          return (
            <li
              key={index}
              style={{
                padding: "6px 8px",
                fontWeight: "bold",
                backgroundColor: "#f5f5f5",
                borderBottom: "1px solid #ddd",
                cursor: "default"
              }}
            >
              {product.name}
            </li>
          );
        }

        const isSelected = selectedIndex === index;

        return (
          <li
            key={index}
            ref={el => itemRefs.current[index] = el}
            onClick={() => handleProductSuggestedClick(product)}
            style={{
              ...liStyle,
              backgroundColor: isSelected ? '#6174DD' : 'transparent',
              color: isSelected ? 'white' : 'inherit',
            }}
            onMouseEnter={() => setSelectedIndex(index)}
            title={`${product?.productName} - ₹${product?.sellPrice?.toLocaleString("en-IN")}`}
          >
            <span style={productNameStyle}>
              {product?.productName} - ₹{product?.sellPrice}
            </span>

            <span style={countBadgeStyle(isSelected)}>
              {product.productCount}
            </span>

            {/* NEW: Edit count button */}
            {onEditCountClick && (
              <IconButton
                size="small"
                title="Update product count"
                onMouseDown={(e) => {
                  e.preventDefault();   // keeps the input focused
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();  // prevents selecting the product
                  onEditCountClick(product);
                }}
                sx={{
                  p: '2px',
                  color: isSelected ? 'white' : '#6174DD',
                }}
              >
                <EditIcon sx={{ fontSize: 16 }} />
              </IconButton>
            )}
          </li>
        );
      })}

      {showAddNew && (
        <div
          ref={el => itemRefs.current[data.length] = el}
          onClick={onAddNewClick}
          style={{
            ...liStyle,
            color: selectedIndex === data.length ? 'white' : "#007bff",
            fontWeight: "bold",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor: selectedIndex === data.length ? '#6174DD' : 'transparent',
          }}
          onMouseEnter={() => setSelectedIndex(data.length)}
        >
          ➕ Add New Product
        </div>
      )}
    </ul>
  );
};

export default ProductSuggestion;